import mixpanel from "mixpanel-browser";
import { useCallback, useEffect, useRef } from "react";

import type { LanguageCode } from "common/types/languageCode";
import { buildTrackingData } from "common/utilities/buildTrackingData";
import { useSelector } from "common/utilities/react-redux";
import type { TrackMeta } from "domains/analytics/types";
import { getSiteLanguage } from "domains/language/selectors";

export const useTrack = () => {
  const siteLanguage = useSelector(getSiteLanguage);

  /**
   * Ref that tracks the value of `siteLanguage`
   *
   * Whenever the value of `siteLanguage` changes, the value of `siteLanguageRef` is updated via a `useEffect`
   *
   * This allows the tracking function to access the value of `siteLanguage` without breaking reference equality
   */
  const siteLanguageRef = useRef<LanguageCode>(siteLanguage);

  useEffect(() => {
    siteLanguageRef.current = siteLanguage;
  }, [siteLanguage]);

  return useCallback(({ name, ...rest }: TrackMeta) => {
    mixpanel.track(name, buildTrackingData(siteLanguageRef.current, rest));
  }, []);
};
